import { findColorsByCompany } from '../../_services/color.service.js';
import { getCompany } from '../../_utils/storage_handler';

export const findAllColors = async () => {
    let res = await findColorsByCompany(getCompany());
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}